import * as Yup from "yup";

export const PhoneInputSchema = Yup.object().shape({
    mobileNumber: Yup.string()
        .length(9, "100")
        .required("99"),
});
